import { LensHomePageProps } from "@snapchat/content-platform-www/generated-src/snapchat/web/stories/props";
import { fetchProps } from "@snapchat/web-proto-props";
import LensHomePage from "../components/homepage/LensHomePage/LensHomePage";
import { FALLBACK_ORIGIN } from "../constants/endpoints";
import { ResponsiveSSRPage } from "@snapchat/web-frame";
import { WWW_DOT_SNAPCHAT_DOT_COM_GA } from "@snapchat/web-analytics-types";
const HomePage = (props) => (<ResponsiveSSRPage isMobileServerSide={props.isMobile}>
    <LensHomePage {...props}/>
  </ResponsiveSSRPage>);
// this is to ensure that we use correct origin value to generate href values in the app.
// in https://lens.snapchat.com, we can use the origin as is, but in other places (e.g. https://www.snapchat.com),
// origin value should have /lens pathname since that is where the app is being served from.
const originBasePathOverrideMap = {
    "https://web-lens.snap": "https://www.snapchat.com/lens",
    "https://www.snapchat.com": "https://www.snapchat.com/lens",
};
/* istanbul ignore next -- cannot test backend functions */
HomePage.getInitialProps = async ({ req }) => {
    const props = await fetchProps(req, LensHomePageProps, WWW_DOT_SNAPCHAT_DOT_COM_GA, FALLBACK_ORIGIN);
    // eslint-disable-next-line no-restricted-globals
    const origin = req ? reqOrigin(req) : window.location.origin;
    return {
        ...props,
        basePath: origin in originBasePathOverrideMap ? originBasePathOverrideMap[origin] : origin,
        skipWebConfigNamespaceProviderInitialization: false,
    };
};
/* istanbul ignore next -- cannot test backend functions */
function reqOrigin(req) {
    const socket = req.socket;
    const proto = req.headers["x-forwarded-proto"] || (socket.encrypted ? "https" : "http");
    const host = req.headers["x-forwarded-host"] || req.headers["host"];
    const url = new URL(req.url || "", `${String(proto)}://${String(host)}`);
    return url.origin;
}
export default HomePage;
